import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private accessToken: string | null = null;
  private apiurl = environment.apiurl + 'nodeapp/'
  constructor(private http: HttpClient, private router: Router,) { }

  getAccessToken() {
    let access_token = localStorage.getItem('access_token');
    return access_token;
  }

  setAccessToken(token: string) {
    this.accessToken = token;
    localStorage.setItem('access_token', token);
  }

  refreshToken(): Observable<{ accessToken: string }> {
    return this.http.post<{ accessToken: string }>(this.apiurl + 'refresh-token', {}, { withCredentials: true }).pipe(map(res => {

      return res;
    }, error => {

      // this.errorAlert();
      return error;
    }));
  }
  logout(refreshErr: HttpErrorResponse) {
    console.log(refreshErr);
    if (refreshErr.status == 403) {
      Swal.fire({
        title: 'Your session has expired. Please log in again',
        text: "You will be logged out of your session.",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, log me out!',
        backdrop: false
      }).then((result) => {
        if (result.isConfirmed) {
          // this.cksrv.login = false;
          // this.cksrv.cookieDel("UID");
          localStorage.removeItem("userDetails");
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigate(['/']);
        }
      });
    } else if (refreshErr.status == 404) {
      const message = refreshErr.error?.message || "Resource or endpoint not found.";

      // Optionally, log out if the error indicates a missing user/resource related to the session
      if (message.toLowerCase().includes("user not found") || message.toLowerCase().includes("session") || message.toLowerCase().includes("User is not active")) {
        Swal.fire({
          title: message,
          text: "You will be logged out of your session.",
          icon: 'warning',
          confirmButtonText: 'OK',
          backdrop: false
        }).then(() => {
          this.performLogout();
        });
      } else {
        return refreshErr;
        // Show generic error message, don't logout
        // Swal.fire({
        //   title: '404 - Not Found',
        //   text: message,
        //   icon: 'error',
        //   confirmButtonText: 'OK',
        //   backdrop: false
        // });
      }
    } else if (refreshErr.status == 400) {
      const { errors } = refreshErr.error;
      const missingList = errors.join('\n• ');
      alert(`Following fields are required :\n• ${missingList}`);
      return missingList;

    }
    else if (refreshErr.status == 429) {
      console.log(refreshErr.error);
      return { status: 429, error: refreshErr.error };

    } else {
      return refreshErr;
    }
  }
  performLogout() {
    // this.cksrv.login = false;
    // this.cksrv.cookieDel("UID");
    localStorage.removeItem("userDetails");
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/']);
  }
}
